module.exports = __webpack_public_path__ + "static/media/utah-logo.711dfa38.png";